module.exports = __webpack_public_path__ + "static/media/NumberlistBlack.b004b3a2.svg";